// extracted by mini-css-extract-plugin
module.exports = {"active":"menu-sidebar_active__3FAp9","logo":"menu-sidebar_logo__MIHnc"};